module.exports = __webpack_public_path__ + "static/media/study 210811.17d6360d.png";